import { CalendarDays, Clock3 } from 'lucide-react'
import * as Popover from '@radix-ui/react-popover'
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'

function parseLocalDateTime(value) {
  if (!value) return null
  const [datePart, timePart = '17:00'] = value.split('T')
  const [year, month, day] = datePart.split('-').map(Number)
  const [hours, minutes] = timePart.split(':').map(Number)
  const parsed = new Date(year, month - 1, day, hours || 0, minutes || 0)
  return Number.isNaN(parsed.getTime()) ? null : parsed
}

function localValue(date) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${year}-${month}-${day}T${hours}:${minutes}`
}

export function DateTimePicker({ value, onChange, disabled = false, 'aria-label': ariaLabel = 'Seleccionar fecha y hora' }) {
  const selected = parseLocalDateTime(value)
  const updateDate = (nextDate) => {
    if (!nextDate) return
    nextDate.setHours(selected?.getHours() ?? 17, selected?.getMinutes() ?? 0, 0, 0)
    onChange?.({ target: { value: localValue(nextDate) } })
  }
  const updateTime = (event) => {
    const base = selected || new Date()
    const [hours, minutes] = event.target.value.split(':').map(Number)
    base.setHours(hours || 0, minutes || 0, 0, 0)
    onChange?.({ target: { value: localValue(base) } })
  }
  return <Popover.Root>
    <Popover.Trigger asChild>
      <button className="shadcn-date-trigger" type="button" disabled={disabled} data-empty={!selected} aria-label={ariaLabel}>
        <CalendarDays/><span>{selected ? format(selected, 'dd MMM yyyy', { locale: es }) : 'Seleccionar fecha'}</span><small>{selected ? format(selected, 'HH:mm') : 'Hora'}</small>
      </button>
    </Popover.Trigger>
    <Popover.Portal>
      <Popover.Content className="shadcn-date-popover" align="end" sideOffset={6} collisionPadding={12}>
        <DayPicker mode="single" selected={selected || undefined} onSelect={updateDate} locale={es} captionLayout="dropdown" startMonth={new Date()} endMonth={new Date(new Date().getFullYear() + 3, 11)} />
        <label className="shadcn-time-field"><Clock3/><span>Hora</span><input type="time" value={selected ? format(selected, 'HH:mm') : '17:00'} onChange={updateTime}/></label>
        <Popover.Arrow className="shadcn-date-arrow"/>
      </Popover.Content>
    </Popover.Portal>
  </Popover.Root>
}
